export const defaultEntity = "piani";
export const entities = ["piani"];
export const labels = {
  piani: "Piani",
};
